module.exports = __webpack_public_path__ + "media/img/uploads/solutions-slant-emergency-management-first-responders-89de97e4090eb7fb4a451a8d5f9a136f.jpg";